import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "../components";
import { logo_color, program_1 } from "./../pngs";
import { getImg, tokenSolver, privTermsAccepted, privGtmKey } from "../utils";
import {
  sendTag,
  event_properties_100_06,
  event_properties_100_07,
} from "../components/CoalitionGtm";
import "./OnboardingPage.scss";

export const OnboardingPage = ({ registerTerms }) => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_100_06());
  }, [gtm]);

  const handleOnboarding = () => {
    localStorage.setItem(privTermsAccepted, true);
    if (gtm) sendTag(gtm, event_properties_100_07());
    registerTerms();
  };

  const [legalsAccepted, setLegalsAccepted] = useState(false);
  const isDisabled = !legalsAccepted ? true : false;

  const title = "Ahora tienes más beneficios";
  const desc = [
    "10 puntos valen $1.00",
    "Puedes llevarte más productos de regalo",
    "Encuentra nuevas marcas aliadas para usar Spin Premia",
  ];

  const terms = (
    <Link to={`/terminos-y-condiciones-del-programa?${tokenSolver()}`}>
      Términos y condiciones
    </Link>
  );
  const priv = (
    <Link to={`/aviso-de-privacidad?${tokenSolver()}`}>
      Aviso de privacidad
    </Link>
  );
  const content = (
    <>
      Leí y acepto los {terms} y {priv} del programa de lealtad
    </>
  );

  return (
    <div className="onboarding-page">
      <div className="logo">{getImg(logo_color)}</div>
      <div className="image">{getImg(program_1)}</div>
      <div className="title">{title}</div>
      <ul className="description">
        {desc.map((dot, idx) => (
          <li key={idx} className="description-item">
            {dot}
          </li>
        ))}
      </ul>
      <div className="checkbox">
        <Checkbox
          isChecked={legalsAccepted}
          checkHandler={(e) => setLegalsAccepted(e)}
        >
          {content}
        </Checkbox>
      </div>
      <button
        className={`control ${isDisabled ? "locked" : ""}`}
        disabled={isDisabled}
        onClick={handleOnboarding}
      >
        Continuar
      </button>
    </div>
  );
};
